<mat-slide-toggle
  id="editSlider"
  (change)="onEditModeChanged($event)"
  [checked]="checked"
  aria-label="Toggles edit mode. Edit mode on allows editing of page content">
  {{ toggleText }}
</mat-slide-toggle>
